import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { msalConfig, loginRequest } from "./authConfig";


const msalInstance = new PublicClientApplication( msalConfig );

const OutlookWrapped = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginPopup( loginRequest ).then( r => { console.log( r ); console.log( instance ); } ).catch(e => {
            console.error(e);
        });
    }

    return (
        <Container fluid className='p-0' style={ { height: 'calc(100vh - 95px)' } }>
            <Row className='tf-page-container' style={ { height: 'calc(100% - 30px)' } }>
                <Col>
                    <Row className='pt-3'>
                        <Col>
                            <Button onClick={handleLogin}>Enable Outlook</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

const Outlook = () => {
    return (
        <MsalProvider instance={msalInstance}>
            <OutlookWrapped />
        </MsalProvider>
    )
}

export default Outlook